import { atom } from "recoil";
import { ISafeMake } from "../types";

export const addStateSafeMake = atom({
  key: "addStateSafeMake",
  default: false,
});
export const editStateSafeMake = atom({
  key: "editStateSafeMake",
  default: false,
});
export const rowEditSafeMake = atom<ISafeMake | undefined>({
  key: "rowEditSafeMake",
  default: undefined,
});

export const selectedRowsStateSafeMake = atom<ISafeMake[]>({
  key: "selectedRowsStateSafeMake",
  default: [],
});

export const safeMakeFilterText = atom({
  key: "safeMakeFilterText",
  default: "",
});

export const safeMakeFetching = atom({
  key: "safeMakeFetching",
  default: true,
});

export const safeMakeReFetching = atom({
  key: "safeMakeReFetching",
  default: false,
});
